import React, {useState} from "react";
import {Button, Container, Form} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import {useHistory} from "react-router-dom";
import MiniLoader from "../components/MiniLoader";
import axios from "axios";
import FeatherIcon from "feather-icons-react";

const VerifyEmail = () => {
    const history = useHistory();
    const { t, i18n } = useTranslation();
    document.title=t("Verify Email")
    const [loader, setLoader] = useState(false)
    const [error, setError] = useState()

    let sendEmail = async (e) => {
        e.preventDefault()
        setLoader(true)

        try {
            await axios.post('/api/v1.0/users/forgot-password/', {
                'email': e.target.email.value,
                'language': i18n.language
            })

            localStorage.setItem('emailVerify', e.target.email.value)
            toast(t("The security code has been sent to your email"), {type: "success"})
            history.push('/security-code')
        }
        catch (error) {
            if (error.response.status === 500) {
                history.push('/500')
            }
            if('error' in error.response.data)
                setError(error.response.data.error)
            else
                toast(t("Please, enter valid email"), {type: "error"})
        }
        finally {
            setTimeout(() => {setLoader(false)}, 200)
        }
    }

    return (
        <div className="auth-card">
                        <h2>{t("Forgot password?")}</h2>
                        <h4>
                            {t("Please enter your email")}
                        </h4>
                        <Form onSubmit={sendEmail} className={loader ? "hide" : ""}>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Control
                                    required
                                    type="email"
                                    name="email"
                                    placeholder="Enter email"
                                />
                            </Form.Group>
                            <div id="match-text" className={error ? "active" : "hide"}>
                                <Form.Text className={`text-muted alarm`}>
                                    <FeatherIcon icon="alert-circle" /> {t(error)}
                                </Form.Text><br/>
                            </div>
                            <Button variant="green" type="submit">
                                {t("Submit")}
                            </Button>
                        </Form>
                        { !loader ? "" : (
                            <div className="center-block">
                                <center>
                                    <MiniLoader />
                                </center>
                            </div>)
                        }
                    </div>
    )
}


export default VerifyEmail
